import React,{useRef,useEffect} from 'react'

import { Spin } from 'antd'
import '../../styles/_index.scss'
import moment from 'moment'

function PrintQuantityStatisticsTable(props) {
    const tableRef = useRef();
    const columnRef = useRef();
    const { loading, list, total, totalWithTimeSlot, newFilter } = props

    const timeOptions = [
        '0h-1h', '1h-2h', '2h-3h', '3h-4h',
        '4h-5h', '5h-6h', '6h-7h', '7h-8h',
        '8h-9h', '9h-10h', '10h-11h', '11h-12h',
        '12h-13h', '13h-14h', '14h-15h', '15h-16h',
        '16h-17h', '17h-18h', '18h-19h', '19h-20h',
        '20h-21h', '21h-22h', '22h-23h', '23h-0h',
    ]
    const checkPeriod = (value) => {
        const currentTime = moment()
        if(newFilter.statistic_date===currentTime.format('YYYY-MM-DD')){
            if (value.includes('Ngoài')) {
                const [startTime, endTime] = value.split('-');
                if (!currentTime.isBetween(moment(startTime, 'HH'), moment(endTime, 'HH'))) return 'PeriodSelect'
            } else {
                const [startTime, endTime] = value.split('-');
                if (currentTime.isBetween(moment(startTime, 'HH'), moment(endTime, 'HH'))) return 'PeriodSelect'
            }
        }
    }
    const handleScroll = () => {
        const th1 = document.querySelector('th:first-child');
        const th2 = document.querySelector('th:nth-child(2)');
        const tbody = document.querySelector('tbody');
        const listBodyRow = tbody.querySelectorAll('tr')

        listBodyRow.forEach(i=>{
            const td2 = i.querySelector('td:nth-child(2)')
            if(th1 && td2){
                td2.style.left = th1.getBoundingClientRect().width + 'px'
            }
        })

        if (th1 && th2) {
          th2.style.left = th1.getBoundingClientRect().width + 'px';
        }
      }


    useEffect(() => {
        const table = columnRef.current;
        handleScroll()
        if (table) {
          const currentTimeCol = table.querySelector('.PeriodSelect')
          const firstTimeCol = table.querySelector('.PeriodTime')
          if (currentTimeCol) {
            currentTimeCol.scrollIntoView({ block: 'nearest', inline: 'end' })
          }else{
            firstTimeCol.scrollIntoView({ block: 'nearest', inline: 'end' })
          }
        }
      }, [newFilter, list]);
    
    return (
        <Spin spinning={loading} tip='Đang tải...' ref={tableRef} onScroll={handleScroll}>
            <table className='table table-bordered table-striped PrintQuantityStatisticsTable' ref={columnRef} id='ExportTable'>
                <thead className='thead-light'>

                    <tr>
                        <th className='text-center' rowSpan={2} style={{ background: '#305496', color: 'white' }}>
                            <p>MÁY IN</p>
                        </th>
                        <th className="text-center" rowSpan={2} style={{ background: '#305496', color: 'white', minWidth:'100px' }}>
                            <p>TỔNG</p>
                        </th>
                        <th className="text-center" colSpan={timeOptions.length} style={{ background: '#305496', color: 'white' }}> THỜI GIAN</th>
                    </tr>
                    <tr>
                        {!!timeOptions.length && timeOptions.map((i, index) => (
                            <th key={index} className={`text-center PeriodTime ${checkPeriod(i)}`} style={{ background: '#8ea9db', color: 'white' }}>{i}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {!!list && list.length > 0 &&
                        <tr>
                            <td className='font-weight-bold text-center'></td>
                            <td className='font-weight-bold text-center'>{total || '-'}</td>
                            {!!timeOptions.length && timeOptions.map((i, index) => (
                                <td key={index} className={`text-center font-weight-bold ${checkPeriod(i)}`}>{!!totalWithTimeSlot ? totalWithTimeSlot[i] || '-' : '-'}</td>
                            ))}
                        </tr>
                    }
                    {
                        !!list && list.length > 0 ? (
                            list.map((item, index) => (
                                <tr key={index}>
                                    <td className='text-center'>{item.printer || '-'}</td>
                                    <td className='font-weight-bold text-center'>{item.total || '-'}</td>
                                    {!!timeOptions.length && timeOptions.map((i, index) => (
                                        <td key={index} className={`text-center ${checkPeriod(i)}`}>
                                            {
                                                item.time_slot && Object.keys(item.time_slot).length > 0 && item.time_slot[i] ? item.time_slot[i] : '-'
                                            }
                                        </td>
                                    ))}
                                </tr>
                            )
                            )

                        ) : (
                            <tr>
                                <td colSpan={timeOptions.length + 2}>No data</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </Spin>
    )
}

export default PrintQuantityStatisticsTable